/** Known host wins over a copied config (including localhost using public/config.js). */
export function telemetryEnvironment(hostname: string, configured?: string): string {
  const known: Record<string, string> = {
    'dev.astralbeam.io': 'michael-local',
    'astralbeam.dev.make.services': 'make-dev',
    'testnet.astralbeam.io': 'testnet',
    localhost: 'michael-local',
    '127.0.0.1': 'michael-local',
  };

  return known[hostname] || configured || hostname;
}
